import React from 'react';
import mapInstance, { MapKit } from './modules/mapkit';
import auth from './modules/auth';
import trip from './modules/trip';
import geo from './modules/geo';
import marketing from './modules/marketing';
import coupon from './modules/coupon';

export type RootStore = {
  mapInstance: MapKit;
  auth: typeof auth;
  trip: typeof trip;
  geo: typeof geo;
  marketing: typeof marketing;
  coupon: typeof coupon;
};

export const store: RootStore = {
  mapInstance,
  auth,
  trip,
  geo,
  marketing,
  coupon
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { mapInstance, auth, trip, geo, marketing, coupon };
